export default {

    // ---------Select Location-------
    maxOnlyAllowed: "Max only allowed {{no}} selection",
    selectionRequired: 'Selection Required',
    pleaseSelectAnyLocation: 'Please select any location',
    itemsAtLeastHave1Row: 'Items at least have (1) row',
    thereAreDocumentsAlreadyExists: 'There are {{exists}} documents already exists',
    atLeastOneAreaIsRequired: 'At least one area is required',
    
    pleaseSelectAtLeastAnyProperty: 'Please select at least any property',
    changesSaved: 'Changes Saved',
    maxAllowed: 'Max allowed ',
    pleaseSelectAtLeast1DataFilter: 'Please select at least (1) data filter',
    invalidUserId: 'Invalid User ID.',
    
}